import { render } from "./mention-list.vue?vue&type=template&id=8624a412"
import script from "./mention-list.vue?vue&type=script&lang=js"
export * from "./mention-list.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/rich-text/mention-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8624a412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8624a412', __exports__)) {
    console.log('reload')
    api.reload('8624a412', __exports__)
  }
  
  module.hot.accept("./mention-list.vue?vue&type=template&id=8624a412", () => {
    console.log('re-render')
    api.rerender('8624a412', render)
  })

}


export default __exports__